import {
    FETCH_SINGLE_EXPENSE_CONTENT,
    FETCH_SINGLE_EXPENSE_CONTENT_SUCCESS,
    FETCH_SINGLE_EXPENSE_CONTENT_FAILED,
    SINGLE_EXPENSE_MESSAGE,
    SINGLE_EXPENSE_MESSAGE_SUCCESS,
    SINGLE_EXPENSE_MESSAGE_FAILED,
    FETCH_EXPENSE_CONTENT,
    FETCH_EXPENSE_CONTENT_FAILED,
    FETCH_EXPENSE_CONTENT_SUCCESS,
    EXPENSE_DELETE__MESSAGE,
    EXPENSE_DELETE_MESSAGE_SUCCESS,
    EXPENSE_DELETE__MESSAGE_FAILED,
    GET_FILTER_EXPENSE,
    GET_FILTER_EXPENSE_FAILED,
    GET_FILTER_EXPENSE_SUCCESS,
} from "../actions/actionTypes";

const initialState = {
    isLoading: true,
    content: {},
    error: false,
    isFormProcessing: false,
    emptyFormData: false,
    floor_plans: [],
    isFilterLoading: false,
    isItemDeleted: false,
};

export default function (state = initialState, { type, payload }) {
    switch (type) {
        case GET_FILTER_EXPENSE:
            return {
                ...state,
                isFilterLoading: true,
            };
        case GET_FILTER_EXPENSE_SUCCESS:
            return {
                ...state,
                isFilterLoading: false,
                content: payload,
            };

        case GET_FILTER_EXPENSE_FAILED:
            return {
                ...state,
                isFilterLoading: false,
                error: payload,
            };
        case FETCH_EXPENSE_CONTENT:
            return {
                ...state,
                isLoading: true,
                content: {},
            };
        case FETCH_EXPENSE_CONTENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                content: payload,
            };
        case FETCH_EXPENSE_CONTENT_FAILED:
            return {
                ...state,
                isLoading: false,
                error: payload,
            };
        case FETCH_SINGLE_EXPENSE_CONTENT:
            return {
                ...state,
                isLoading: true,
                content: {},
            };
        case FETCH_SINGLE_EXPENSE_CONTENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                content: payload,
            };
        case FETCH_SINGLE_EXPENSE_CONTENT_FAILED:
            return {
                ...state,
                isLoading: false,
                error: payload,
            };
        case SINGLE_EXPENSE_MESSAGE:
            return {
                ...state,
                isFormProcessing: true,
            };
        case SINGLE_EXPENSE_MESSAGE_SUCCESS:
            return {
                ...state,
                isFormProcessing: false,
                emptyFormData: true,
            };
        case SINGLE_EXPENSE_MESSAGE_FAILED:
            return {
                ...state,
                isFormProcessing: false,
                error: payload,
            };
        case EXPENSE_DELETE__MESSAGE:
            return {
                ...state,
                isItemDeleted: true,
            };
        case EXPENSE_DELETE_MESSAGE_SUCCESS:
            return {
                ...state,
                isItemDeleted: false,
                emptyFormData: true,
            };
        case EXPENSE_DELETE__MESSAGE_FAILED:
            return {
                ...state,
                isItemDeleted: false,
                error: payload,
            };
        default:
            return state;
    }
}
